import { render, staticRenderFns } from "./companyseccode.vue?vue&type=template&id=000b04dc&scoped=true"
import script from "./companyseccode.vue?vue&type=script&lang=js"
export * from "./companyseccode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000b04dc",
  null
  
)

export default component.exports